var exports = {
  "kL": "HandoffCodeDisplay.module__container___SXl6Y0",
  "DD": "HandoffCodeDisplay.module__title___SXl6Y0",
  "h_": "HandoffCodeDisplay.module__description___SXl6Y0",
  "w5": "HandoffCodeDisplay.module__expiredDescription___SXl6Y0",
  "ZP": "HandoffCodeDisplay.module__codeSection___SXl6Y0",
  "cg": "HandoffCodeDisplay.module__codeLabel___SXl6Y0",
  "w8": "HandoffCodeDisplay.module__codeDisplay___SXl6Y0",
  "IL": "HandoffCodeDisplay.module__codeChar___SXl6Y0",
  "lr": "HandoffCodeDisplay.module__codeSeparator___SXl6Y0",
  "O1": "HandoffCodeDisplay.module__timer___SXl6Y0",
  "u1": "HandoffCodeDisplay.module__spinner___SXl6Y0",
  "Fh": "HandoffCodeDisplay.module__spinnerIcon___SXl6Y0",
  "t0": "HandoffCodeDisplay.module__spin___SXl6Y0",
  "z3": "HandoffCodeDisplay.module__error___SXl6Y0",
};

module.exports = exports;
